import script from "./ForumVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumVideo.vue?vue&type=script&setup=true&lang=js"

import "./ForumVideo.vue?vue&type=style&index=0&id=47f7d4d9&lang=less"

const __exports__ = script;

export default __exports__